import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/overview/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
